module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"order":{"product_options":"Selected: {0}"}}}')
  delete Component.options._Ctor
}
